import MessageBus from '@/Utils/message/message-bus';
const excelMap = {
    fuels: {
        燃料类型: 'fuelType',
        计量单位: 'calculatingUnit',
        '热值（MJ/计量单位)': 'calorificFuel',
        '价格(元/计量单位)': 'priceFuel',
        CO2排放系数: 'PollutantDischargeFactor.pollutionCO2',
        NOx排放系数: 'PollutantDischargeFactor.pollutionNOX',
        SO2排放系数: 'PollutantDischargeFactor.pollutionSO2',
        灰尘排放系数: 'PollutantDischargeFactor.dust',
    },
    常数电价: {
        类型: 'name',
        '电价(元/kWh)': {
            route: 'purchasePriceModel.params',
            deal: (data: Array<{ value: string[] }>): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return [data[0].value[0]];
            },
        },
    },
    分时电价: {
        类型: 'name',
        时间: {
            route: 'purchasePriceModel.params',
            deal: (data: Array<{ value: string[] }>): number[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return [...Array(data[0].value.length)].map((x, index) => index);
            },
        },
        '分时电价(元/kwh)': {
            route: 'purchasePriceModel.params',
            deal: (data: Array<{ value: string[] }>): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return data[0].value;
            },
        },
    },
    阶梯电价: {
        类型: 'name',
        '容量下限(kwh)': {
            route: 'purchasePriceModel.params',
            deal: (data: Array<{ value: string[]; quantity: string }>): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return data.map((x) => x.quantity);
            },
        },
        '阶梯电价(元/kwh)': {
            route: 'purchasePriceModel.params',
            deal: (data: Array<{ value: string[]; quantity: string }>): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return data.map((x) => x.value[0]);
            },
        },
    },
    '分时+阶梯': {
        类型: 'name',
        '阶段(kwh)': {
            route: 'purchasePriceModel.params',
            deal: (data: Array<{ value: string[] }>): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return [...Array(24)].map((x, index) => `${index}h`);
            },
        },
    },
    '热-按热量计价': {
        模型名称: 'name',
        计价方式: 'purchasePriceModel.pricingMethod',
        '价格（元/kWh）': 'purchasePriceModel.price',
    },
    '热-按用量计价': {
        模型名称: 'name',
        计价方式: 'purchasePriceModel.pricingMethod',
        '价格（元/t）': 'purchasePriceModel.price',
    },
    '热-按采暖面积计价': {
        模型名称: 'name',
        计价方式: 'purchasePriceModel.pricingMethod',
        '价格（元/㎡）': 'purchasePriceModel.price',
    },
    '冷-按热量计价': {
        模型名称: 'name',
        计价方式: 'purchasePriceModel.pricingMethod',
        '价格（元/kWh）': 'purchasePriceModel.price',
    },
    '冷-按用量计价': {
        模型名称: 'name',
        计价方式: 'purchasePriceModel.pricingMethod',
        '价格（元/t）': 'purchasePriceModel.price',
    },
    '冷-按供冷面积计价': {
        模型名称: 'name',
        计价方式: 'purchasePriceModel.pricingMethod',
        '价格（元/㎡）': 'purchasePriceModel.price',
    },
    光伏: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '光伏板面积(m²)': 'ratedParam.SinglePanelArea',
        '光电转换效率(%)': 'ratedParam.ConversionEfficiency',
        功率因数: 'ratedParam.PowerFactor',
        '最大发电功功率(kW)': 'operationalConstraints.maxPowerGenerating',
        '采购成本(万元/台)': 'economicParam.PurchaseCost',
        '固定运维成本(万元/年)': 'economicParam.FixedOMCost',
        '可变运维成本(元/kWh)': 'economicParam.VariableOMCost',
    },
    风机: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '额定发电量(kW)': 'ratedParam.RatedPowerGenerating',
        '额定风速(m/s)': 'ratedParam.RatedWindSpeed',
        '切入风速(m/s)': 'ratedParam.CutinWindSpeed',
        '切出风速(m/s)': 'ratedParam.CutoutWindSpeed',
        '轮毂高度(m)': 'ratedParam.HubHeight',
        功率因数: 'ratedParam.PowerFactor',
        '采购成本(万元/台)': 'economicParam.PurchaseCost',
        '固定运维成本(万元/年)': 'economicParam.FixedOMCost',
        '可变运维成本(元/kWh)': 'economicParam.VariableOMCost',
    },

    热管式太阳能集热器: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '局部压降系数(kPa/(m³·s⁻¹)²)': 'ratedParam.LocalPressureDropCoe',
        '集热器面积(m²)': 'ratedParam.PlateArea',
        '集热效率(%)': 'ratedParam.CollectionEfficiency',
        '最小供水温度 (℃)': 'operationalConstraints.MiniOutletTemp',
        '最大供水温度 (℃)': 'operationalConstraints.MaxOutletTemp',
        '采购成本(万元/台)': 'economicParam.PurchaseCost',
        '固定运维成本(万元/年)': 'economicParam.FixedOMCost',
        '可变运维成本(元/kWh)': 'economicParam.VariableOMCost',
    },

    蓄电池: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '充电效率(%)': 'ratedParam.ChargingEfficiency',
        '放电效率(%)': 'ratedParam.DischargingEfficiency',
        功率因数: 'ratedParam.PowerFactor',
        '最大充电功率(kW)': 'operationalConstraints.MaxChargingPower',
        '最大放电功率(kW)': 'operationalConstraints.MaxDischargingPower',
        '电池最大容量(kWh)': 'operationalConstraints.PowerStorageLimit',
        '采购成本(万元/台)': 'economicParam.PurchaseCost',
        '固定运维成本(万元/年)': 'economicParam.FixedOMCost',
        '可变运维成本(元/kWh)': 'economicParam.VariableOMCost',
    },
    储水罐: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '入口侧局部压降系数(kPa/(m³·s⁻¹)²)': 'ratedParam.InletLocalPressureDropCoe',
        '出口侧局部压降系数(kPa/(m³·s⁻¹)²)': 'ratedParam.OutletLocalPressureDropCoe',
        '罐底面积(m²)': 'ratedParam.FloorArea',
        '最大允许水位高度(m)': 'operationalConstraints.MaxWaterLevel',
        '最小允许水位高度(m)': 'operationalConstraints.MiniWaterLevel',
        '采购成本(万元/台)': 'economicParam.PurchaseCost',
        '固定运维成本(万元/年)': 'economicParam.FixedOMCost',
        '可变运维成本(元/kWh)': 'economicParam.VariableOMCost',
    },
    蓄冰空调: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '额定蓄冷功率(kW)': 'ratedParam.ratedChargingCool',
        '蓄冷效率(%)': 'ratedParam.chargingEfficiency',
        '额定放冷功率(kW)': 'ratedParam.ratedDischargingCool',
        '放冷效率(%)': 'ratedParam.dischargingEfficiency',
        // 功率因数: 'ratedParam.PowerFactor',
        '最大冷水出口温度(℃)': 'operationalConstraints.maxColdWaterOutletTemp',
        '最小冷水出口温度(℃)': 'operationalConstraints.miniColdWaterOutletTemp',
        '最大冷水进口温度(℃)': 'operationalConstraints.maxColdWaterInletTemp',
        '最小冷水进口温度(℃)': 'operationalConstraints.miniColdWaterInletTemp',
        '蓄冰空调最大容量(kWh)': 'operationalConstraints.capacity',
        '采购成本(万元/台)': 'economicParam.PurchaseCost',
        '固定运维成本(万元/年)': 'economicParam.FixedOMCost',
        '可变运维成本(元/kWh)': 'economicParam.VariableOMCost',
    },
    变压器: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '额定容量(MVA)': 'ratedParam.windingMVABase',
        '一次侧短路电阻(Ω)': 'ratedParam.shortCircuitResistance',
        '一次侧短路电抗(Ω)': 'ratedParam.shortCircuitImpedance',
        '变压器非标准变比(p.u.)': 'ratedParam.wind2Ratio',
        '最大非标准变比(p.u.)': 'operationalConstraints.maxWind2Ratio',
        '最小非标准变比(p.u.)': 'operationalConstraints.miniWind2Ratio',
        '采购成本(万元/台)': 'economicParam.PurchaseCost',
        '固定运维成本(万元/年)': 'economicParam.FixedOMCost',
    },
    传输线: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '单位长度电阻(Ω/km)': 'ratedParam.resistanceOfUnitLength',
        '单位长度电抗(Ω/km)': 'ratedParam.reactanceOfUnitLength',
        '单位长度容抗(MΩ*km)': 'ratedParam.chargingBofUnitLength',
        '采购成本(万元/km)': 'economicParam.PurchaseCost',
        '固定维护成本(万元/(km·年))': 'economicParam.FixedOMCost',
    },

    模块化多电平变流器: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '额定电压(kV)': 'ratedParam.BaseVoltage',
        '采购成本(万元/台)': 'economicParam.PurchaseCost',
        '固定运维成本(万元/年)': 'economicParam.FixedOMCost',
    },

    管道: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '管道内径(mm)': 'ratedParam.interDiameter',
        '管道壁厚(mm)': 'ratedParam.thickness',
        '管道粗糙度(mm)': 'ratedParam.roughness',
        '管道总传热系数(W/(m·K))': 'ratedParam.heatExchangeFactor',
        '管道设计压力(MPa)': 'operationalConstraints.maxPressure',
        '采购成本(万元/km)': 'economicParam.PurchaseCost',
        '固定维护成本(万元/(km·年))': 'economicParam.FixedOMCost',
    },

    '电负荷-典型日负荷': {
        负荷名称: 'loadName',
        负荷模型: {
            route: 'loadParam.model',
            deal: (data: string): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return ['典型日负荷'];
            },
        },
        负荷类型: 'loadParam.rough_load.buildingType',
        '建筑面积(m2)': 'loadParam.rough_load.Floorage',
        '单位建筑面积负荷指标(W/㎡)': 'loadParam.rough_load.UnitFloorageElectricalLoadIndex',
        功率因数: 'loadParam.rough_load.PowerFactor',
    },
    '电负荷-分月详细负荷-区分工作日': {
        负荷名称: 'loadName',
        负荷模型: {
            route: 'loadParam.model',
            deal: (data: string): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return ['分月详细负荷'];
            },
        },
        区分工作日和休息日: 'loadParam.detail_load.isDayOff',
        功率因数: 'loadParam.detail_load.PowerFactor',
    },
    '电负荷-分月详细负荷-不区分工作日': {
        负荷名称: 'loadName',
        负荷模型: {
            route: 'loadParam.model',
            deal: (data: string): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return ['分月详细负荷'];
            },
        },
        区分工作日和休息日: 'loadParam.detail_load.isDayOff',
        功率因数: 'loadParam.detail_load.PowerFactor',
    },
    '电负荷-自定义': {
        负荷名称: 'loadName',
        负荷模型: {
            route: 'loadParam.model',
            deal: (data: string): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return ['自定义负荷'];
            },
        },
    },
    /**
     * 2021-5-24 更新
     * 建模仿真模块 电负荷
     */
    '电负荷建模仿真-典型日负荷': {
        负荷名称: 'loadName',
        负荷模型: {
            route: 'loadParam.model',
            deal: (data: string): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return ['典型日负荷'];
            },
        },
        负荷类型: 'loadParam.rough_load.buildingType',
        '建筑面积(m2)': 'loadParam.rough_load.Floorage',
        '单位建筑面积负荷指标(W/㎡)': 'loadParam.rough_load.UnitFloorageElectricalLoadIndex',
        // '电负荷指标(kW)': 'loadParam.rough_load.ElectricalLoadIndex',
        功率因数: 'loadParam.rough_load.PowerFactor',
    },
    '电负荷建模仿真-分月详细负荷-区分工作日': {
        负荷名称: 'loadName',
        负荷模型: {
            route: 'loadParam.model',
            deal: (data: string): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return ['分月详细负荷'];
            },
        },
        区分工作日和休息日: 'loadParam.detail_load.isDayOff',
        功率因数: 'loadParam.detail_load.PowerFactor',
    },
    '电负荷建模仿真-分月详细负荷-不区分工作日': {
        负荷名称: 'loadName',
        负荷模型: {
            route: 'loadParam.model',
            deal: (data: string): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return ['分月详细负荷'];
            },
        },
        区分工作日和休息日: 'loadParam.detail_load.isDayOff',
        功率因数: 'loadParam.detail_load.PowerFactor',
    },
    '电负荷建模仿真-自定义': {
        负荷名称: 'loadName',
        负荷模型: {
            route: 'loadParam.model',
            deal: (data: string): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return ['自定义负荷'];
            },
        },
    },

    '充电桩负荷-区分工作日': {
        负荷名称: 'loadName',
        区分工作日和休息日: 'loadParam.loadCurve.isDayOff',
    },
    '充电桩负荷-不区分工作日': {
        负荷名称: 'loadName',
        区分工作日和休息日: 'loadParam.loadCurve.isDayOff',
    },
    //建模仿真 设备信息库
    光伏_建模仿真: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '光伏板面积(m²)': 'ratedParam.SinglePanelArea',
        '光电转换效率(%)': 'ratedParam.ConversionEfficiency',
        功率因数: 'ratedParam.PowerFactor',
        '最大发电功功率(kW)': 'operationalConstraints.maxPowerGenerating',
    },
    风机_建模仿真: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '额定发电量(kW)': 'ratedParam.RatedPowerGenerating',
        '额定风速(m/s)': 'ratedParam.RatedWindSpeed',
        '切入风速(m/s)': 'ratedParam.CutinWindSpeed',
        '切出风速(m/s)': 'ratedParam.CutoutWindSpeed',
        '轮毂高度(m)': 'ratedParam.HubHeight',
        功率因数: 'ratedParam.PowerFactor',
    },
    热管式太阳能集热器_建模仿真: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '局部压降系数(kPa/(m³·s⁻¹)²)': 'ratedParam.LocalPressureDropCoe',
        '集热器面积(m²)': 'ratedParam.PlateArea',
        '集热效率(%)': 'ratedParam.CollectionEfficiency',
        '最小供水温度 (℃)': 'operationalConstraints.MiniOutletTemp',
        '最大供水温度 (℃)': 'operationalConstraints.MaxOutletTemp',
    },
    蓄电池_建模仿真: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '充电效率(%)': 'ratedParam.ChargingEfficiency',
        '放电效率(%)': 'ratedParam.DischargingEfficiency',
        功率因数: 'ratedParam.PowerFactor',
        '最大充电功率(kW)': 'operationalConstraints.MaxChargingPower',
        '最大放电功率(kW)': 'operationalConstraints.MaxDischargingPower',
        '电池最大容量(kWh)': 'operationalConstraints.PowerStorageLimit',
    },
    储水罐_建模仿真: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '入口侧局部压降系数(kPa/(m³·s⁻¹)²)': 'ratedParam.InletLocalPressureDropCoe',
        '出口侧局部压降系数(kPa/(m³·s⁻¹)²)': 'ratedParam.OutletLocalPressureDropCoe',
        '罐底面积(m²)': 'ratedParam.FloorArea',
        '最大允许水位高度(m)': 'operationalConstraints.MaxWaterLevel',
        '最小允许水位高度(m)': 'operationalConstraints.MiniWaterLevel',
    },
    蓄冰空调_建模仿真: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '额定蓄冷功率(kW)': 'ratedParam.ratedChargingCool',
        '蓄冷效率(%)': 'ratedParam.chargingEfficiency',
        '额定放冷功率(kW)': 'ratedParam.ratedDischargingCool',
        '放冷效率(%)': 'ratedParam.dischargingEfficiency',
        功率因数: 'ratedParam.PowerFactor',
        '最大冷水出口温度(℃)': 'operationalConstraints.maxColdWaterOutletTemp',
        '最小冷水出口温度(℃)': 'operationalConstraints.miniColdWaterOutletTemp',
        '最大冷水进口温度(℃)': 'operationalConstraints.maxColdWaterInletTemp',
        '最小冷水进口温度(℃)': 'operationalConstraints.miniColdWaterInletTemp',
        '蓄冰空调最大容量(kWh)': 'operationalConstraints.capacity',
    },
    变压器_建模仿真: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '额定容量(MVA)': 'ratedParam.windingMVABase',
        '一次侧短路电阻(Ω)': 'ratedParam.shortCircuitResistance',
        '一次侧短路电抗(Ω)': 'ratedParam.shortCircuitImpedance',
        '变压器非标准变比(p.u.)': 'ratedParam.wind2Ratio',
        '最大非标准变比(p.u.)': 'operationalConstraints.maxWind2Ratio',
        '最小非标准变比(p.u.)': 'operationalConstraints.miniWind2Ratio',
    },
    传输线_建模仿真: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '单位长度电阻(Ω/km)': 'ratedParam.resistanceOfUnitLength',
        '单位长度电抗(Ω/km)': 'ratedParam.reactanceOfUnitLength',
        '单位长度容抗(MΩ*km)': 'ratedParam.chargingBofUnitLength',
    },
    模块化多电平变流器_建模仿真: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '额定电压(kV)': 'ratedParam.BaseVoltage',
    },
    管道_建模仿真: {
        生产厂商: 'manufacturer',
        设备型号: 'equipType',
        '管道内径(mm)': 'ratedParam.interDiameter',
        '管道壁厚(mm)': 'ratedParam.thickness',
        '管道粗糙度(mm)': 'ratedParam.roughness',
        '管道总传热系数(W/(m·K))': 'ratedParam.heatExchangeFactor',
        '管道设计压力(MPa)': 'operationalConstraints.maxPressure',
    },

    /**
     * 采暖制冷负荷
     * 2022-10-9 更新
     */
    '采暖制冷负荷-典型日负荷': {
        负荷名称: 'loadName',
        负荷模型: {
            route: 'loadParam.model',
            deal: (data: string): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return ['典型日负荷'];
            },
        },
        负荷类型: 'loadParam.rough_load.buildingType',
        '建筑面积(m2)': 'loadParam.rough_load.Floorage',
        '采暖面积/建筑面积': 'loadParam.rough_load.HeatingAreaRatio',
        '空调面积/建筑面积': 'loadParam.rough_load.CoolingAreaRatio',
        '单位建筑面积热负荷指标(正值，W/㎡)': 'loadParam.rough_load.UnitFloorageHeatingLoadIndex',
        '单位建筑面积冷负荷指标(负值，W/㎡)': 'loadParam.rough_load.UnitFloorageCoolingLoadIndex',
        日采暖制冷起始时间: 'loadParam.rough_load.dayCycleStart',
        日采暖制冷结束时间: 'loadParam.rough_load.dayCycleEnd',
    },
    '采暖制冷负荷-分月详细负荷-不区分工作日': {
        负荷名称: 'loadName',
        负荷模型: {
            route: 'loadParam.model',
            deal: (data: string): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return ['分月详细负荷'];
            },
        },
        '建筑面积(m2)': 'loadParam.detail_load.Floorage',
        区分工作日和休息日: 'loadParam.detail_load.isDayOff',
    },
    '采暖制冷负荷-分月详细负荷-区分工作日': {
        负荷名称: 'loadName',
        负荷模型: {
            route: 'loadParam.model',
            deal: (data: string): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return ['分月详细负荷'];
            },
        },
        '建筑面积(m2)': 'loadParam.detail_load.Floorage',
        区分工作日和休息日: 'loadParam.detail_load.isDayOff',
    },
    '采暖制冷负荷-自定义负荷': {
        负荷名称: 'loadName',
        负荷模型: {
            route: 'loadParam.model',
            deal: (data: string): string[] => {
                if (!data) {
                    MessageBus.Notification('error', { description: '数据类型有问题，请联系管理员处理！', message: '提示' });
                }
                return ['自定义负荷'];
            },
        },
    },
};
export default excelMap;
